<template>
  <ThemeProvider :theme="theme">
    <div id="app">
      <Header></Header>
      <router-view></router-view>
      <Footer></Footer>
    </div>
  </ThemeProvider>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import Footer from '@/components/Footer'
import { theme } from '@/thems'
import { injectGlobal, ThemeProvider } from 'vue-styled-components'

injectGlobal`
  .no-scroll {
    overflow: hidden;
  }

  .title {

  }
`

export default {
  name: 'App',
  data: () => ({
    theme: theme
  }),
  created () {
    this.getLS()
  },
  methods: {
    getLS () {
      this.$store.dispatch('getLS')
    }
  },
  components: {
    Header,
    Footer,
    ThemeProvider
  }
}
</script>

<style lang="scss">
@import "assets/scss/style";

#app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue